import React from "react";
import Style from "styles/components/case_study.module.scss";
import classNames from 'classnames';
import CaseStudyCard from 'components/CaseStudyCard';

const CaseStudyPresenter = ({ caseStudyItems }) => {
  const list = Array.isArray(caseStudyItems) ? caseStudyItems : [];
  return (
    <section className={classNames(Style.caseStudyBody)}>
      <div className={classNames(Style.gridContainer)}>
        {list.map((caseStudy, idx) => (
            <CaseStudyCard
            key={idx}
            id={caseStudy.id}
            storeName={caseStudy.storeName}
            customerName={caseStudy.customerName}
            storeLogo={caseStudy.storeLogo}
            thmImageSrc={caseStudy.thumbnailImage}
            dtlImageSrc={caseStudy.detailImage}
            />
        ))}
      </div>
    </section>
  );
};


const CaseStudyGrid = ({caseStudyList}) => {
  return <CaseStudyPresenter caseStudyItems={caseStudyList} />;
};

export default CaseStudyGrid;
